(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var lastFocusedTrigger = null;

  function getModal() {
    return document.getElementById('ob-modal-currency-root');
  }

  function getDialog(modal) {
    return modal ? modal.querySelector('[role="dialog"]') : null;
  }

  function setTriggersExpanded(expanded) {
    document.querySelectorAll('.language-selector').forEach(function (el) {
      el.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice
      .call(container.querySelectorAll(FOCUSABLE))
      .filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return;

    lastFocusedTrigger = document.activeElement;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ob-currency-modal-open');
    setTriggersExpanded(true);

    // Move focus into the dialog.
    var focusable = getFocusable(getDialog(modal));
    if (focusable.length) {
      focusable[0].focus();
    }
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ob-currency-modal-open');
    setTriggersExpanded(false);

    // Restore focus to the element that opened the modal.
    if (lastFocusedTrigger && typeof lastFocusedTrigger.focus === 'function') {
      lastFocusedTrigger.focus();
    }
    lastFocusedTrigger = null;
  }

  function isOpen() {
    var modal = getModal();
    return modal ? modal.classList.contains('is-open') : false;
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !isOpen()) return;

    var dialog = getDialog(getModal());
    var focusable = getFocusable(dialog);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  window.showCurrencySelector = openModal;
  window.hideCurrencySelector = closeModal;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // Open from the header trigger (click or keyboard).
    document.body.addEventListener('click', function (e) {
      var trigger = e.target.closest('.language-selector');
      if (!trigger) return;
      e.preventDefault();
      openModal();
    });

    document.body.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var trigger = e.target.closest('.language-selector');
      if (!trigger) return;
      e.preventDefault();
      openModal();
    });

    // Close from any element marked data-ob-close (close button, cancel, backdrop).
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('[data-ob-close]')) {
        e.preventDefault();
        closeModal();
      }
    });

    // Escape closes; Tab is trapped within the dialog.
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    });
  });
})();
